// web/src/components/ceremony/ShareCeremonyPanel.tsx — the "share these" panel the
// opener sees right after convening an unseal (content-guide §1.3 consequential).
// It shows the one-time join code (what3words words) + PIN to pass to holders
// out-of-band so they can join the ceremony. The code grants entry to THIS
// ceremony only; it carries no shard or key (R11). The opener then enters the
// animated ceremony to gather shards.
import React from 'react';
import { ArrowRight } from 'lucide-react';
import Modal from '../Modal';
import { Icon } from '../ui/Icon';
import { CodeBlock } from '../ui';
import type { ConveneShare } from '../records/useConveneUnseal';

export function ShareCeremonyPanel({
  share,
  onEnter,
  onClose,
}: {
  share: ConveneShare;
  onEnter: () => void;
  onClose: () => void;
}): React.JSX.Element {
  return (
    <Modal
      title="Share these with your holders"
      subtitle="Ceremony open"
      maxWidth={460}
      onClose={onClose}
      footer={
        <button type="button" className="btn btn-primary" onClick={onEnter}>
          <Icon icon={ArrowRight} size="sm" /> Enter the ceremony
        </button>
      }
    >
      <p style={{ color: 'var(--color-text2)', marginTop: 0, lineHeight: 1.5 }}>
        Pass the join code and PIN to your holders over a channel you trust. They
        enter them under <strong style={{ color: 'var(--color-text)' }}>Join an unseal</strong>{' '}
        to reach this ceremony. The PIN is shown once — it isn't stored in the clear.
      </p>

      <label className="field-label" htmlFor="share-words">
        Join code
      </label>
      <CodeBlock code={share.joinWords || '(no code issued)'} />

      <label className="field-label" htmlFor="share-pin" style={{ marginTop: '0.8rem' }}>
        One-time PIN
      </label>
      <CodeBlock code={share.pin} />
    </Modal>
  );
}

export default ShareCeremonyPanel;
